module.exports = __webpack_public_path__ + "static/media/MHRP77N0008.6c2fce9b.svg";